import { AuthRoutes } from './routes';

export const RouteTranslationMap: Record<string, string> = {
  [AuthRoutes.InvalidUser]: 'invalidUser',
  [AuthRoutes.InvalidInvitation]: 'inactiveInvitation',
};
